import request from '@/utils/request';

// 角色删除
export function userRoleDeleteApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/roles/deleteRole',
    method: 'post',
    data
  });
}
// 云仓的初始权限列表
export function getYCAuthListApi() {
  return request({
    baseURL: '/steward/web/',
    url: '/yuncang/getYcMenuList',
    method: 'post'
  })
}
// 更新云仓的权限
export function modifyYcRoleMenuApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/yuncang/modifyRoleMenu',
    method: 'post',
    data
  })
}
// 根据角色查询对应的云仓权限
export function queryYcRoleMenuApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/yuncang/queryYcRoleMenu',
    method: 'post',
    data
  })
}
// 批量变更角色
export function batchModifyRoleApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/employee/batchModifyRole',
    method: 'post',
    data
  })
}
// 角色权限初始化
export function viewRolePreApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/roles/initRolePage',
    method: 'post',
    data
  });
}
